<template>
  <div id="register" class="general" :class="{ recaptcha: recaptcha }">
    <vue-headful title="Regístrate en Iberbox" description="Crea una cuenta de Iberbox y disfruta del almacenamiento seguro más avanzado para profesionales y empresas." keywords="iberbox, copias de seguridad, cifrado punto a punto, nube segura" image="https://iberbox.com/img/logo.svg" />
    <div class="contenedor-body">
      <div class="contenedor-login visible-xs" v-show="createMode">
        <form @submit="submit" autocomplete="off" v-if="tarifaSeleccionada">
          <div class="container-form">
            <div class="steps">
              <template v-if="accountHandleJoin == null">
                <div :class="[createMode === 1 ? 'step-activo' : 'step']">
                  <div class="image">
                    <package-icon size="1.5x" class="custom-class"></package-icon>
                  </div>
                  <p>{{ $t('prompts.selectPlan') }}</p>
                </div>
                <div class="separador"></div>
              </template>
              <div :class="[createMode === 2 ? 'step-activo' : 'step']">
                <div class="image">
                  <user-icon size="1.5x" class="custom-class"></user-icon>
                </div>
                <p>{{ $t('login.yourData') }}</p>
              </div>
              <template v-if="accountHandleJoin == null">
                <div class="separador"></div>
                <div :class="[createMode === 3 ? 'step-activo' : 'step']">
                  <div class="image">
                    <edit-icon size="1.5x" class="custom-class"></edit-icon>
                  </div>
                  <p>{{ $t('login.finalize') }}</p>
                </div>
              </template>
            </div>

            <div v-if="createMode == 2 && !isVerified" :class="[isFocusName ? 'campo-activo' : 'campo']">
              <input class="input input--block" type="text" id="firstnameInput" v-model="firstname" :placeholder="$t('login.firstname')" @focus="focusNameOn" @blur="focusNameOff" focus>
            </div>
            <div v-if="createMode == 2 && !isVerified" :class="[isFocusSurname ? 'campo-activo' : 'campo']">
              <input class="input input--block" type="text" id="lastnameInput" v-model="lastname" :placeholder="$t('login.lastname')" @focus="focusSurnameOn" @blur="focusSurnameOff">
            </div>
            <div v-if="createMode == 2 && !isVerified" :class="[isFocusEmail ? 'campo-activo' : 'campo']">
              <input class="input input--block" type="email" id="usernameInput" v-model="username" :placeholder="$t('login.username')" :disabled="emailDisabled" @focus="focusEmailOn" @blur="focusEmailOff">
            </div>

            <div v-if="createMode == 2 && !isVerified" class="terms">
              <input class="input" type="checkbox" id="checkbox" v-model="checked">
              <label for="checkbox" v-html=" $t('login.termsOfService') "></label>
            </div>

            <input v-if="createMode == 2 && !isVerified" class="button button--block" id="registerButton" type="submit" :value="$t('login.verify')">
          </div>

          <div class="email" v-if="createMode == 2 && isVerified">
            <p>{{ username }}</p>
            <p v-if="this.accountHandleJoin === null && this.accountKeyJoin === null && this.registrationId === null" @click="changeEmail" class="change-email">{{ $t('login.changeEmail') }}</p>
          </div>
          
          <div class="pin" v-if="createMode == 2 && isVerified">
            <h2>{{ $t('login.verify') }}</h2>
            <p>{{ $t('login.checkInbox') }}</p>
            <v-otp-input ref="otpInput" class="otp" input-classes="otp-input" separator=" " :num-inputs="6" :is-input-num="true" @on-complete="handleOnComplete"/>
          </div>

          <div v-if="createMode == 2 && isVerified" class="password-container">
            <div :class="[isFocusPassword ? 'campo-activo' : 'campo']">
              <password id="passwordInput" v-model="password" @score="changeScore" :placeholder="$t('login.password')" :badge="false" :showStrengthMeter="false" :toggle="true" :labelHide="$t('login.hidePassword')" :labelShow="$t('login.showPassword')" @focus="focusPasswordOn" @blur="focusPasswordOff"/>
            </div>
            <div class="scorebar">
              <div class="scorebar-value" :style="scoreBarStyles"></div>
            </div>
            <div :class="[isFocusPasswordConfirm ? 'campo-activo' : 'campo']">
              <input class="input input--block" type="password" id="passwordConfirmInput" v-model="passwordConfirm" :placeholder="$t('login.passwordConfirm')" autocomplete="new-password" @focus="focusPasswordConfirmOn" @blur="focusPasswordConfirmOff"/>
            </div>
            <button type="button" @click="selectPaymentMethod" class="button button--block">
              <span v-if="accountHandleJoin != null || precioTarifa === 0">{{ $t('login.finalize') }}</span>
              <span v-else-if="tarifaSeleccionada.id !== 99">{{ $t('buttons.selectPaymentMethod') }}</span>
              <span v-else>{{ $t('pricing.continue') }}</span>
            </button>
          </div>

          <div v-if="createMode == 1" class="select-rate">
            <select v-model="planKey">
              <option v-for="([key,]) in tarifas.entries()" :key="key" :value="key">{{ key }}</option>
            </select>
            <p v-html="$t('login.tailoredPlan')"></p>
          </div>

          <div v-if="createMode === 1" class="container-plans">
            <div v-if="tarifaSeleccionada.id !== 99" class="radio-buttons">
              <div class="radio-buttons">
                <div class="radio-button">
                  <input type="radio" id="period-radio-monthly" :value="Module.SubscriptionPeriod.SP_MONTHLY.value" v-model="period" :disabled="!isMonthlyPeriodAvailable">
                  <label for="period-radio-monthly">{{ $t('login.monthly') }}</label>
                </div>
                <div class="radio-button">
                  <input type="radio" id="period-radio-yearly" :value="Module.SubscriptionPeriod.SP_YEARLY.value" v-model="period" :disabled="!isYearlyPeriodAvailable">
                  <label for="period-radio-yearly">{{ $t('login.annual') }}</label>
                </div>
              </div>
            </div>
            <h3>{{ $t('login.haveChosen') }}<b>{{ tarifaSeleccionada.name }}</b></h3>
            <span>{{ $t('login.featuresPlan') }}</span>
            <h2>{{ precioTarifa.toFixed(2) }}€<b>{{ tarifaSeleccionada.period === Module.SubscriptionPeriod.SP_MONTHLY.value ? $t('login./month') : $t('login./year') }}</b></h2>
            <p v-if="tBAdditional == '' && (tarifaSeleccionada.id === 102 || tarifaSeleccionada.id === 103 || tarifaSeleccionada.id === 104 || tarifaSeleccionada.id === 105 || tarifaSeleccionada.id === 106 || tarifaSeleccionada.id === 107)" class="features">{{ $t('login.storage') }}<b>{{ humanSize(tarifaSeleccionada.storage) }}</b></p>
            <p v-else-if="tBAdditional != '' && tarifaSeleccionada.period == Module.SubscriptionPeriod.SP_MONTHLY.value && (tarifaSeleccionada.id === 102 || tarifaSeleccionada.id === 103 || tarifaSeleccionada.id === 104 || tarifaSeleccionada.id === 105 || tarifaSeleccionada.id === 106 || tarifaSeleccionada.id === 107)" class="features">{{ $t('login.storage') }}<b>1Tb (12.99€) + {{ tBAdditional }}Tb Adicionales ({{ tBAdditional }}*5.99€/Tb)</b></p>
            <p v-else-if="tBAdditional != '' && tarifaSeleccionada.period == Module.SubscriptionPeriod.SP_YEARLY.value && (tarifaSeleccionada.id === 102 || tarifaSeleccionada.id === 103 || tarifaSeleccionada.id === 104 || tarifaSeleccionada.id === 105 || tarifaSeleccionada.id === 106 || tarifaSeleccionada.id === 107)" class="features">{{ $t('login.storage') }}<b>1Tb (129.90€) + {{ tBAdditional }}Tb Adicionales ({{ tBAdditional }}*59.90€/Tb)</b></p>
            <p v-else class="features">{{ $t('login.storage') }}<b>{{ humanSize(tarifaSeleccionada.storage) }}</b></p>
            <div v-if="tarifaSeleccionada.id === 99" style="display: flex; align-items: center;">
              <p class="features">{{ $t('settings.encryptionAlgorithm') }}: <b>{{ $t('settings.AES128') }}</b></p>
              <div class="speed">
                <zap-icon size="1.5x" class="custom-class"></zap-icon>
                <span>{{ $t('login.fast') }}</span>
              </div>
            </div>
            <div v-else style="display: flex; align-items: center;">
              <p class="features">{{ $t('settings.encryptionAlgorithm') }}: <b>{{ $t('settings.AES256') }}</b></p>
              <div class="speed">
                <lock-icon size="1.5x" class="custom-class"></lock-icon>
                <span>{{ $t('login.safer') }}</span>
              </div>
            </div>
            <p class="details"><b>{{ $t('login.completeSuite') }}</b>{{ $t('login.textCompleteSuite') }}</p>
            <p v-if="tarifaSeleccionada.id === 102 || tarifaSeleccionada.id === 103 || tarifaSeleccionada.id === 104 || tarifaSeleccionada.id === 105 || tarifaSeleccionada.id === 106 || tarifaSeleccionada.id === 107" class="details"><b>{{ $t('login.additional') }}</b>{{ $t('login.textAdditionalEmpresas') }}</p>
            <p v-else class="details"><b>{{ $t('login.additional') }}</b>{{ $t('login.textAdditional') }}</p>

            <div class="discount" v-if="allowDiscountCode">
              <input class="input input--block" type="text" v-model="referrerCodeTemp" :placeholder="$t('login.discountCoupon')">
              <button @click="applyCoupon" :aria-label="$t('buttons.apply')" :title="$t('buttons.apply')" class="button" id="finish">
                <span>{{ $t('buttons.apply') }}</span>
              </button>
            </div>

            <button @click="choosePlan" class="button button--block" id="registerButton" :aria-label="$t('pricing.continue')" :title="$t('pricing.continue')">
              <span>{{ $t('pricing.continue') }}</span>
            </button>
          </div>

          <div v-if="createMode === 3 && tarifaSeleccionada.id === 99" class="step3">
            <div class="free-rate">
              <h2 style="padding: 0;">{{ $t('login.finish') }}</h2>
              <p>{{ $t('login.textFinish1') }}{{ humanSize(tarifaSeleccionada.storage) }}{{ $t('login.textFinish2') }}</p>
              <a href="https://iberbox.com/tarifas" target="_blank" :aria-label="$t('buttons.checkPlans')" :title="$t('buttons.checkPlans')" class="button">
                <span>{{ $t('buttons.checkPlans') }}</span>
              </a>
              <button @click="finish" :aria-label="$t('login.finalize')" :title="$t('login.finalize')" class="button" id="finish">
                <span>{{ $t('login.finalize') }}</span>
              </button>
              <img src="/img/icons/backgrounds/undraw_air_support_re_nybl.svg">
            </div>
          </div>

         <div class="step3" v-else-if="createMode === 3 && tarifaSeleccionada.id !== 99">
            <h2>{{ $t('pricing.setUpPaymentMethod') }}</h2>
            <div class="radio-buttons-pay">
              <div class="radio-button">
                <input type="radio" id='credit' value='credit' v-model="payMethod">
                <label for='credit'>{{ $t('settings.creditCard') }}</label>
              </div>
              <div class="radio-button">
                <input type="radio" id='transfer' value='transfer' v-model="payMethod">
                <label for='transfer'>{{ $t('settings.wireTransfer') }}</label>
              </div>
              <div class="radio-button">
                <input type="radio" id='receipt' value='receipt' v-model="payMethod">
                <label for='receipt'>{{ $t('settings.bankReceipt') }}</label>
              </div>
              <div class="radio-button">
                <input type="radio" id='coupon' value='coupon' v-model="payMethod">
                <label for='coupon'>{{ $t('login.haveCode') }}</label>
              </div>
              <div class="radio-button">
                <input type="radio" id='skip' value='skip' v-model="payMethod">
                <label for='skip'>{{ $t('promo.skipStep') }}</label>
              </div>
            </div>
            <div v-if="payMethod === 'credit'" class="pay-method">
              <p class="text">{{ $t('login.creditText') }}</p>
              <input type="checkbox" id="accept" name="accept" v-model="userAccepts" disabled>
              <label for="accept" v-html="$t('pricing.acceptPricingTermsCard')"></label>
              <form ref="redsysForm" :action="paymentUrl" method="POST">
                <input type="hidden" name="Ds_SignatureVersion" :value="signatureVersion"/>
                <input type="hidden" name="Ds_MerchantParameters" :value="paymentInfo"/>
                <input type="hidden" name="Ds_Signature" :value="signature"/>
              </form>
              <button @click="configureCard" :aria-label="$t('buttons.configureCard')" :title="$t('buttons.configureCard')" class="button" id="finish">
                <span>{{ $t('buttons.configureCard') }}</span>
              </button>
            </div>
            <div v-else-if="payMethod === 'coupon'" class="pay-method">
              <input class="input input--block" type="text" v-model="resellerCode" :placeholder="$t('login.resellerCode')">
              <button @click="checkCode" :aria-label="$t('buttons.checkCode')" :title="$t('buttons.checkCode')" class="button" id="finish">
                <span>{{ $t('buttons.checkCode') }}</span>
              </button>
            </div>
            <div v-else-if="payMethod === 'transfer'" class="pay-method-transfer">
              <p class="text">{{ $t('settings.makeTranfer') }}</p>
              <div class="container-transfer">
                <h3>{{ $t('settings.iban') }}</h3>
                <p>ES23 0081 7831 3200 0123 2328</p>
                <h3>{{ $t('pricing.invoiceSubject') }}</h3>
                <p>{{ username }}</p>
              </div>
              <div class="container-check">
                <input type="checkbox" id="accept" name="accept" v-model="userAccepts" disabled>
                <label for="accept" v-html="$t('pricing.acceptPricingTermsTransfer')"></label>
                <button @click="configureTransfer" :aria-label="$t('login.finalize')" :title="$t('login.finalize')" class="button" id="finish">
                  <span>{{ $t('login.finalize') }}</span>
                </button>
              </div>
            </div>
            <div v-else-if="payMethod === 'receipt'" class="pay-method">
              <input class="input input--block" type="text" v-model="iban" :placeholder="$t('settings.iban')">
              <input style="margin-bottom: 45px;" class="input input--block" type="text" v-model="accountHolder" :placeholder="$t('pricing.accountHolder')">
              <input type="checkbox" id="accept" name="accept" v-model="userAccepts" disabled>
              <label for="accept" v-html="$t('pricing.acceptPricingTermsBank')"></label>
              <button style="margin-top: 30px; padding: 8px 40px;" @click="configureBank" :aria-label="$t('login.finalize')" :title="$t('login.finalize')" class="button" id="finish">
                <span>{{ $t('login.finalize') }}</span>
              </button>
            </div>
            <div v-else class="pay-method">
              <button @click="finish" :aria-label="$t('login.finalize')" :title="$t('login.finalize')" class="button" id="finish">
                <span>{{ $t('login.finalize') }}</span>
              </button>
            </div>
          </div>
          
          <div v-if="recaptcha" id="recaptcha"></div>
        </form>
      </div>
      <div class="contenedor-publicidad">
        <div class="contenedor-texto">
          <img src="/img/icons/Login/ibbWhite.svg" class="desktop">
          <div class="texto">
            <h2>{{ $t('login.signup') }}</h2>
            <p>{{ $t('login.joinSecureCloud') }}</p>
          </div>
          <a href="https://www.iberbox.com/terminos-de-servicio/" target="_blank">
            <span>{{ $t('login.termsService') }}</span>
          </a>
        </div>
        <div class="mensaje">
          <template v-if="error !== ''">
            <div class="wrong">
              <alert-circle-icon size="1.5x" class="custom-class"></alert-circle-icon>
              <p v-html="error"></p>
            </div>
          </template>
          <template v-else-if="info !== ''">
            <div class="info">
              <p>{{ info }}</p>
            </div>
          </template>
        </div>
      </div>
      <div class="contenedor-login hidden-xs" style="overflow-y: scroll;" v-show="createMode">
        <form @submit="submit" autocomplete="off" v-if="tarifaSeleccionada">
          <div class="container-form">
            <div class="steps">
              <template v-if="accountHandleJoin == null">
                <div :class="[createMode === 1 ? 'step-activo' : 'step']">
                  <div class="image">
                    <package-icon size="1.5x" class="custom-class"></package-icon>
                  </div>
                  <p>{{ $t('prompts.selectPlan') }}</p>
                </div>
                <div class="separador"></div>
              </template>
              <div :class="[createMode === 2 ? 'step-activo' : 'step']">
                <div class="image">
                  <user-icon size="1.5x" class="custom-class"></user-icon>
                </div>
                <p>{{ $t('login.yourData') }}</p>
              </div>
              <template v-if="accountHandleJoin == null">
                <div class="separador"></div>
                <div :class="[createMode === 3 ? 'step-activo' : 'step']">
                  <div class="image">
                    <edit-icon size="1.5x" class="custom-class"></edit-icon>
                  </div>
                  <p>{{ $t('login.finalize') }}</p>
                </div>
              </template>
            </div>

            <div v-if="createMode == 2 && !isVerified" :class="[isFocusName ? 'campo-activo' : 'campo']">
              <input class="input input--block" type="text" id="firstnameInput" v-model="firstname" :placeholder="$t('login.firstname')" @focus="focusNameOn" @blur="focusNameOff" focus>
            </div>
            <div v-if="createMode == 2 && !isVerified" :class="[isFocusSurname ? 'campo-activo' : 'campo']">
              <input class="input input--block" type="text" id="lastnameInput" v-model="lastname" :placeholder="$t('login.lastname')" @focus="focusSurnameOn" @blur="focusSurnameOff">
            </div>
            <div v-if="createMode == 2 && !isVerified" :class="[isFocusEmail ? 'campo-activo' : 'campo']">
              <input class="input input--block" type="email" id="usernameInput" v-model="username" :placeholder="$t('login.username')" :disabled="emailDisabled" @focus="focusEmailOn" @blur="focusEmailOff">
            </div>

            <div v-if="createMode == 2 && !isVerified" class="terms">
              <input class="input" type="checkbox" id="checkbox" v-model="checked">
              <label for="checkbox" v-html=" $t('login.termsOfService') "></label>
            </div>

            <input v-if="createMode == 2 && !isVerified" class="button button--block" id="registerButton" type="submit" :value="$t('login.verify')">
          </div>

          <div class="email" v-if="createMode == 2 && isVerified">
            <p>{{ username }}</p>
            <p v-if="this.accountHandleJoin === null && this.accountKeyJoin === null && this.registrationId === null" @click="changeEmail" class="change-email">{{ $t('login.changeEmail') }}</p>
          </div>
          
          <div class="pin" v-if="createMode == 2 && isVerified">
            <h2>{{ $t('login.verify') }}</h2>
            <p>{{ $t('login.checkInbox') }}</p>
            <v-otp-input ref="otpInput" class="otp" input-classes="otp-input" separator=" " :num-inputs="6" :is-input-num="true" @on-complete="handleOnComplete"/>
          </div>

          <div v-if="createMode == 2 && isVerified" class="password-container">
            <div :class="[isFocusPassword ? 'campo-activo' : 'campo']">
              <password id="passwordInput" v-model="password" @score="changeScore" :placeholder="$t('login.password')" :badge="false" :showStrengthMeter="false" :toggle="true" :labelHide="$t('login.hidePassword')" :labelShow="$t('login.showPassword')" @focus="focusPasswordOn" @blur="focusPasswordOff"/>
            </div>
            <div class="scorebar">
              <div class="scorebar-value" :style="scoreBarStyles"></div>
            </div>
            <div :class="[isFocusPasswordConfirm ? 'campo-activo' : 'campo']">
              <input class="input input--block" type="password" id="passwordConfirmInput" v-model="passwordConfirm" :placeholder="$t('login.passwordConfirm')" autocomplete="new-password" @focus="focusPasswordConfirmOn" @blur="focusPasswordConfirmOff"/>
            </div>
            <button type="button" @click="selectPaymentMethod" class="button button--block">
              <span v-if="accountHandleJoin != null || precioTarifa === 0">{{ $t('login.finalize') }}</span>
              <span v-else-if="tarifaSeleccionada.id !== 99">{{ $t('buttons.selectPaymentMethod') }}</span>
              <span v-else>{{ $t('pricing.continue') }}</span>
            </button>
          </div>

          <div v-if="createMode == 1" class="select-rate">
            <select v-model="planKey">
              <option v-for="([key,]) in tarifas.entries()" :key="key" :value="key">{{ key }}</option>
            </select>
            <p v-html="$t('login.tailoredPlan')"></p>
          </div>

          <div v-if="createMode === 1" class="container-plans">
            <div v-if="tarifaSeleccionada.id !== 99" class="radio-buttons">
              <div class="radio-buttons">
                <div class="radio-button">
                  <input type="radio" id="period-radio-monthly" :value="1" v-model="period" :disabled="!isMonthlyPeriodAvailable">
                  <label for="period-radio-monthly">{{ $t('login.monthly') }}</label>
                </div>
                <div class="radio-button">
                  <input type="radio" id="period-radio-yearly" :value="2" v-model="period" :disabled="!isYearlyPeriodAvailable">
                  <label for="period-radio-yearly">{{ $t('login.annual') }}</label>
                </div>
              </div>
            </div>
            <h3>{{ $t('login.haveChosen') }}<b>{{ tarifaSeleccionada.name }}</b></h3>
            <span>{{ $t('login.featuresPlan') }}</span>
            <h2>{{ precioTarifa.toFixed(2) }}€<b>{{ tarifaSeleccionada.period === Module.SubscriptionPeriod.SP_MONTHLY.value ? $t('login./month') : $t('login./year') }}</b></h2>
            <p v-if="tBAdditional == '' && (tarifaSeleccionada.id === 102 || tarifaSeleccionada.id === 103 || tarifaSeleccionada.id === 104 || tarifaSeleccionada.id === 105 || tarifaSeleccionada.id === 106 || tarifaSeleccionada.id === 107)" class="features">{{ $t('login.storage') }}<b>{{ humanSize(tarifaSeleccionada.storage) }}</b></p>
            <p v-else-if="tBAdditional != '' && tarifaSeleccionada.period == Module.SubscriptionPeriod.SP_MONTHLY.value && (tarifaSeleccionada.id === 102 || tarifaSeleccionada.id === 103 || tarifaSeleccionada.id === 104 || tarifaSeleccionada.id === 105 || tarifaSeleccionada.id === 106 || tarifaSeleccionada.id === 107)" class="features">{{ $t('login.storage') }}<b>1Tb (16.99€) + {{ tBAdditional }}Tb Adicionales ({{ tBAdditional }}*5.99€/Tb)</b></p>
            <p v-else-if="tBAdditional != '' && tarifaSeleccionada.period == Module.SubscriptionPeriod.SP_YEARLY.value && (tarifaSeleccionada.id === 102 || tarifaSeleccionada.id === 103 || tarifaSeleccionada.id === 104 || tarifaSeleccionada.id === 105 || tarifaSeleccionada.id === 106 || tarifaSeleccionada.id === 107)" class="features">{{ $t('login.storage') }}<b>1Tb (169.90€) + {{ tBAdditional }}Tb Adicionales ({{ tBAdditional }}*59.90€/Tb)</b></p>
            <p v-else class="features">{{ $t('login.storage') }}<b>{{ humanSize(tarifaSeleccionada.storage) }}</b></p>
            <div v-if="tarifaSeleccionada.id === 99" style="display: flex; align-items: center;">
              <p class="features">{{ $t('settings.encryptionAlgorithm') }}: <b>{{ $t('settings.AES128') }}</b></p>
              <div class="speed">
                <zap-icon size="1.5x" class="custom-class"></zap-icon>
                <span>{{ $t('login.fast') }}</span>
              </div>
            </div>
            <div v-else style="display: flex; align-items: center;">
              <p class="features">{{ $t('settings.encryptionAlgorithm') }}: <b>{{ $t('settings.AES256') }}</b></p>
              <div class="speed">
                <lock-icon size="1.5x" class="custom-class"></lock-icon>
                <span>{{ $t('login.safer') }}</span>
              </div>
            </div>
            <p class="details"><b>{{ $t('login.completeSuite') }}</b>{{ $t('login.textCompleteSuite') }}</p>
            <p v-if="tarifaSeleccionada.id === 102 || tarifaSeleccionada.id === 103 || tarifaSeleccionada.id === 104 || tarifaSeleccionada.id === 105 || tarifaSeleccionada.id === 106 || tarifaSeleccionada.id === 107" class="details"><b>{{ $t('login.additional') }}</b>{{ $t('login.textAdditionalEmpresas') }}</p>
            <p v-else class="details"><b>{{ $t('login.additional') }}</b>{{ $t('login.textAdditional') }}</p>

            <div class="discount" v-if="allowDiscountCode">
              <input class="input input--block" type="text" v-model="referrerCodeTemp" :placeholder="$t('login.discountCoupon')">
              <button @click="applyCoupon" :aria-label="$t('buttons.apply')" :title="$t('buttons.apply')" class="button" id="finish">
                <span>{{ $t('buttons.apply') }}</span>
              </button>
            </div>

            <button @click="choosePlan" class="button button--block" id="registerButton" :aria-label="$t('pricing.continue')" :title="$t('pricing.continue')">
              <span>{{ $t('pricing.continue') }}</span>
            </button>
          </div>

          <div v-if="createMode === 3 && tarifaSeleccionada.id === 99" class="step3">
            <div class="free-rate">
              <h2 style="padding: 0;">{{ $t('login.finish') }}</h2>
              <p>{{ $t('login.textFinish1') }}{{ humanSize(tarifaSeleccionada.storage) }}{{ $t('login.textFinish2') }}</p>
              <a href="https://iberbox.com/tarifas" target="_blank" :aria-label="$t('buttons.checkPlans')" :title="$t('buttons.checkPlans')" class="button">
                <span>{{ $t('buttons.checkPlans') }}</span>
              </a>
              <button @click="finish" :aria-label="$t('login.finalize')" :title="$t('login.finalize')" class="button" id="finish">
                <span>{{ $t('login.finalize') }}</span>
              </button>
              <img src="/img/icons/backgrounds/undraw_air_support_re_nybl.svg">
            </div>
          </div>

          <div class="step3" v-else-if="createMode === 3 && tarifaSeleccionada.id !== 99">
            <h2>{{ $t('pricing.setUpPaymentMethod') }}</h2>
            <div class="radio-buttons-pay">
              <div class="radio-button">
                <input type="radio" id='credit' value='credit' v-model="payMethod">
                <label for='credit'>{{ $t('settings.creditCard') }}</label>
              </div>
              <div class="radio-button">
                <input type="radio" id='transfer' value='transfer' v-model="payMethod">
                <label for='transfer'>{{ $t('settings.wireTransfer') }}</label>
              </div>
              <div class="radio-button">
                <input type="radio" id='receipt' value='receipt' v-model="payMethod">
                <label for='receipt'>{{ $t('settings.bankReceipt') }}</label>
              </div>
              <div class="radio-button">
                <input type="radio" id='coupon' value='coupon' v-model="payMethod">
                <label for='coupon'>{{ $t('login.haveCode') }}</label>
              </div>
              <div class="radio-button">
                <input type="radio" id='skip' value='skip' v-model="payMethod">
                <label for='skip'>{{ $t('promo.skipStep') }}</label>
              </div>
            </div>
            <div v-if="payMethod === 'credit'" class="pay-method">
              <p class="text">{{ $t('login.creditText') }}</p>
              <input type="checkbox" id="accept" name="accept" v-model="userAccepts" disabled>
              <label for="accept" v-html="$t('pricing.acceptPricingTermsCard')"></label>
              <form ref="redsysForm" :action="paymentUrl" method="POST">
                <input type="hidden" name="Ds_SignatureVersion" :value="signatureVersion"/>
                <input type="hidden" name="Ds_MerchantParameters" :value="paymentInfo"/>
                <input type="hidden" name="Ds_Signature" :value="signature"/>
              </form>
              <button @click="configureCard" :aria-label="$t('buttons.configureCard')" :title="$t('buttons.configureCard')" class="button" id="finish">
                <span>{{ $t('buttons.configureCard') }}</span>
              </button>
            </div>
            <div v-else-if="payMethod === 'coupon'" class="pay-method">
              <input class="input input--block" type="text" v-model="resellerCode" :placeholder="$t('login.resellerCode')">
              <button @click="checkCode" :aria-label="$t('buttons.checkCode')" :title="$t('buttons.checkCode')" class="button" id="finish">
                <span>{{ $t('buttons.checkCode') }}</span>
              </button>
            </div>
            <div v-else-if="payMethod === 'transfer'" class="pay-method-transfer">
              <p class="text">{{ $t('settings.makeTranfer') }}</p>
              <div class="container-transfer">
                <h3>{{ $t('settings.iban') }}</h3>
                <p>ES23 0081 7831 3200 0123 2328</p>
                <h3>{{ $t('pricing.invoiceSubject') }}</h3>
                <p>{{ username }}</p>
              </div>
              <div class="container-check">
                <input type="checkbox" id="accept" name="accept" v-model="userAccepts" disabled>
                <label for="accept" v-html="$t('pricing.acceptPricingTermsTransfer')"></label>
                <button @click="configureTransfer" :aria-label="$t('login.finalize')" :title="$t('login.finalize')" class="button" id="finish">
                  <span>{{ $t('login.finalize') }}</span>
                </button>
              </div>
            </div>
            <div v-else-if="payMethod === 'receipt'" class="pay-method">
              <input class="input input--block" type="text" v-model="iban" :placeholder="$t('settings.iban')">
              <input style="margin-bottom: 45px;" class="input input--block" type="text" v-model="accountHolder" :placeholder="$t('pricing.accountHolder')">
              <input type="checkbox" id="accept" name="accept" v-model="userAccepts" disabled>
              <label for="accept" v-html="$t('pricing.acceptPricingTermsBank')"></label>
              <button style="margin-top: 30px; padding: 8px 40px;" @click="configureBank" :aria-label="$t('login.finalize')" :title="$t('login.finalize')" class="button" id="finish">
                <span>{{ $t('login.finalize') }}</span>
              </button>
            </div>
            <div v-else class="pay-method">
              <button @click="finish" :aria-label="$t('login.finalize')" :title="$t('login.finalize')" class="button" id="finish">
                <span>{{ $t('login.finalize') }}</span>
              </button>
            </div>
          </div>
          
          <div v-if="recaptcha" id="recaptcha"></div>
        </form>
      </div>
    </div>
  </div>
</template>

<script async src="https://www.googletagmanager.com/gtag/js?id=AW-369408594"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'AW-369408594');
</script>

<script>
import * as auth from '@/utils/auth'
import { name, logoURL, recaptcha, recaptchaKey, signup } from '@/utils/constants'
import OtpInput from "@bachdgvn/vue-otp-input";
import Password from 'vue-password-strength-meter'
import vueHeadful from 'vue-headful';
import { mapState, mapMutations } from 'vuex'
import { UserIcon, PercentIcon, AlertCircleIcon, MailIcon, PackageIcon, EditIcon, ZapIcon, LockIcon } from 'vue-feather-icons'
import { files as api } from '@/api'
import filesize from 'filesize'

export default {
  name: 'register',
  computed: {
    ...mapState([ 'accountHandleJoin', 'accountKeyJoin', 'registrationId' ]),
    signup: () => signup,
    name: () => name,
    logoURL: () => logoURL,
    allowDiscountCode() {
      if (!this.tarifaSeleccionada) return false;
      if (this.precioTarifa === 0 && this.discount === '') {
        return false;
      }
      return true;
    },
    precioTarifa() {
      if (!this.tarifaSeleccionada) return 0;
      let total = this.tarifaSeleccionada.amount;
      if (this.tarifaSeleccionada.discount) {
        total -= this.tarifaSeleccionada.discount;
      }
      if (this.discount !== '') {
        let discount = (total * this.discount)/100;
        total -= discount;
      }
      return 1.21 * total;
    },
    tarifaSeleccionada() {
      if (!this.tarifas.has(this.planKey)) return null;
      let options = this.tarifas.get(this.planKey);
      let tarifa = options[this.period];
      if (!tarifa) {
        let option = options.filter(b => b.period)[0];
        if (!option) {
          throw new Error("[Register] No option available for the selected plan.");
        }
        this.period = option.period;
        tarifa = option;
      }
      return tarifa;
    },
    tBAdditional() {
      if (this.tarifaSeleccionada.name.includes('+')) {
        let temp = this.tarifaSeleccionada.name.split('+')
        if (temp[1].includes('1')) {
          return 1;
        } else if (temp[1].includes('2')) {
          return 2;
        }
      }
      return '';
    },
    isMonthlyPeriodAvailable() {
      return !!this.tarifas.get(this.planKey)[Module.SubscriptionPeriod.SP_MONTHLY.value];
    },
    isYearlyPeriodAvailable() {
      return !!this.tarifas.get(this.planKey)[Module.SubscriptionPeriod.SP_YEARLY.value];
    },
    scoreBarStyles() {
      var widthBar = ((this.passwordScore+1)/5)*100 + '%';
      return{width: widthBar};
    },
  },
  data: function () {
    return {
      Module,
      createMode: 0,
      error: '',
      firstname: "",
      lastname: "",
      username: '',
      password: '',
      passwordScore: -1,
      recaptcha: recaptcha,
      passwordConfirm: '',
      referrerCodeTemp: '',
      pin: '',
      id: '',
      checked: false,
      emailDisabled: false,
      isFocusName: false,
      isFocusSurname: false,
      isFocusEmail: false,
      isFocusPassword: false,
      isFocusPasswordConfirm: false,
      isFocusCode: false,
      tarifas: new Map(),
      features: 15,
      precios: [],
      discount: '',
      isVerified: false,
      period: Module.SubscriptionPeriod.SP_MONTHLY.value,
      planKey: '',
      payMethod: 'credit',
      userAccepts: true,
      signatureVersion: '',
      paymentInfo: '',
      paymentUrl: '',
      signature: '',
      resellerCode: '',
      info: '',
      iban: '',
      accountHolder: '',
      subscriptionOptionsCount: 0,
    }
  },
  components: {
    Password,
    'v-otp-input': OtpInput,
    'vue-headful': vueHeadful,
    UserIcon,
    PercentIcon,
    AlertCircleIcon,
    MailIcon,
    PackageIcon,
    EditIcon,
    ZapIcon,
    LockIcon
  },
  async mounted () {
    if (this.accountHandleJoin != null && this.accountKeyJoin != '' && this.registrationId != '') {
      this.createMode = 2;
    } else {
      this.createMode = 1;
      try {
        var subscriptionOptions = await api.getSubscriptionOptionsWithFeatures(this.features);
        this.subscriptionOptionsCount = subscriptionOptions.length;
        if (this.subscriptionOptionsCount === 1) {
          this.period = Module.SubscriptionPeriod.SP_YEARLY.value;
        }
        this.tarifas = subscriptionOptions
          .reduce((acc, o) => {
            const option = {...o, amount: o.amount / 100.0, discount: o.discount / 100.0};
            if (acc.has(option.name)) {
              let options = acc.get(option.name);
              options[option.period] = option;
              acc.set(option.name, options);
            } else {
              let options = [];
              options[option.period] = option;
              acc.set(option.name, options);
            }
            return acc;
          }, new Map());
          // .filter(({period, features, name, id}) => features == this.features)
          // .sort((a, b) => a.storage - b.storage);
        let [name, options] = this.tarifas.entries().next().value;
        [this.planKey, this.period] = [name, options.filter(o => o.period)[0].period];
      } catch (e) {
        this.$showError(e)
      }
    }

    if (this.$route.query.email) {
      this.username = Base64.decode(this.$route.query.email);
      this.emailDisabled = true;
    }

    if (this.$route.query.firstname) {
      this.firstname = Base64.decode(this.$route.query.firstname);
    }

    if (this.$route.query.lastname) {
      this.lastname = Base64.decode(this.$route.query.lastname);
    }

    if (this.$route.query.id && this.firstname.length != 0 && this.lastname.length != 0) {
      this.id = this.$route.query.id;
      setTimeout(function()
      { 
        document.getElementById('passwordInput').autocomplete = "new-password";
        document.getElementsByClassName("Password__toggle")[0].getElementsByTagName("button")[0].tabIndex=-1
      }, 0);
    }

    if (this.$route.query.pin) {
      this.pin = this.$route.query.pin;
    }

    if (this.$route.query.coupon) { 
      this.referrerCodeTemp = Base64.decode(this.$route.query.coupon);
    }

    if (!recaptcha) return

    window.grecaptcha.render('recaptcha', {
      sitekey: recaptchaKey
    })
  },
  methods: {
    ...mapMutations([ 'setAccountHandleJoin', 'setAccountKeyJoin', 'setRegistrationId' ]),
    async applyCoupon() {
      var action = await ibb.getCouponInfo(this.referrerCodeTemp)
      if (!action.error.type) {
        this.discount = action.intValue
        this.info = this.$t('login.couponApplied');
        var thisComponent = this;
        setTimeout(function(){ thisComponent.info = '' }, 5000);
      } else {
        this.discount = ''
      }
    },
    async configureCard() {
      var action = await ibb.getPaymentInfo(1);
      this.paymentInfo = action.paymentInfo.info;
      this.signature = action.paymentInfo.signature;
      this.signatureVersion = action.paymentInfo.signatureVersion;
      this.paymentUrl = action.paymentInfo.url;

      await this.$nextTick();
      this.$refs["redsysForm"].submit();
      this.gtag_report_conversion()
      return;
    },
    async configureTransfer () {
      await ibb.addBankTransferAsPaymentMethod();
      this.finalize();
    },
    async configureBank () {
      if (this.iban === '') {
        this.$showError(this.$t('settings.enterIban'))
        return
      } else if (this.accountHolder === '') {
        this.$showError(this.$t('settings.enterAccountDetails'))
        return
      } else {
        var action = await ibb.addDirectDebitAsPaymentMethod(this.iban, this.accountHolder);
        if (action.error.type) {
          this.$showError(this.$t('settings.ibanNumberNotValid'))
          return
        } else {
          this.finalize();
        }
      }
    },
    async checkCode() {
      if (this.resellerCode === '') {
        this.$showError(this.$t('settings.enterResellerCode'))
        return
      } else {
        var action = await ibb.addResellerCodeAsPaymentMethod(this.resellerCode);
        if (action.error.type) {
          this.$showError(this.$t('settings.resellerCodeInvalid'))
          return
        } else {
          this.finalize();
        }
      }
      try {
        await auth.getNodes();
      } catch (e) {
        this.$showError(e)
      }
    },
    finalize() {
      this.gtag_report_conversion()
      this.$router.push({ path: '/cloud' }).catch(() => {})
      window.history.go('/cloud');
    },
    humanSize: function (storage) {
      if (storage !== undefined) {
        return filesize(storage)
      }
    },
    focusNameOn () {
      this.isFocusName = true;
    },
    focusNameOff () {
      this.isFocusName = false;
    },
    focusSurnameOn () {
      this.isFocusSurname = true;
    },
    focusSurnameOff () {
      this.isFocusSurname = false;
    },
    focusEmailOn () {
      this.isFocusEmail = true;
    },
    focusEmailOff () {
      this.isFocusEmail = false;
    },
    focusPasswordOn () {
      this.isFocusPassword = true;
    },
    focusPasswordOff () {
      this.isFocusPassword = false;
    },
    focusPasswordConfirmOn () {
      this.isFocusPasswordConfirm = true;
    },
    focusPasswordConfirmOff () {
      this.isFocusPasswordConfirm = false;
    },
    focusCodeOn () {
      this.isFocusCode = true;
    },
    focusCodeOff () {
      this.isFocusCode = false;
    },
    handleOnComplete: async function (value) {
      this.pin = parseInt(value);
      setTimeout(function(){ document.getElementById('passwordInput').focus(); }, 0);
    },
    changeScore (score) {
      this.passwordScore = score;
    },
    changeEmail () {
      this.username = '';
      this.password = '';
      this.passwordConfirm = '';
      this.passwordScore = -1;
      this.pin = '';
      this.id = '';
      this.error = '';
      this.referrerCodeTemp = '';
      this.isVerified = false;
    },
    choosePlan() {
      if (this.planKey == '') {
        this.setError(this.$t('login.noSelectRate'))
        return;
      }
      var thisComponent = this;
      setTimeout(function(){ thisComponent.error = '' }, 5000);
      this.createMode = 2
    },
    finish() {
      this.$router.push({ path: '/cloud' })
    },
    async submit (event) {
      event.preventDefault()
      event.stopPropagation()

      const button = document.getElementById('registerButton');
      if (!button || button.disabled) {
          return;
      }

      let redirect = this.$route.query.redirect
      if (redirect === '' || redirect === undefined || redirect === null) {
        redirect = '/promo'
      }

      let captcha = ''
      if (recaptcha) {
        captcha = window.grecaptcha.getResponse()

        if (captcha === '') {
          this.setError(this.$t('login.wrongCredentials'))
          return
        }
      }

      if (this.createMode == 2) {
        if (this.firstname.length == 0) {
          this.setError(this.$t('login.enterFirstname'))
          return;
        }
        if (this.lastname.length == 0) {
          this.setError(this.$t('login.enterLastname'))
          return;
        }
        if (!this.username || this.username.length == 0) {
          this.setError(this.$t('login.enterEmail'))
          return;
        }
        if (!this.checked) {
          this.setError(this.$t('login.acceptTerms'))
          return;
        }

        try {
          button.disabled = true;
          if (this.accountHandleJoin !== null && this.accountKeyJoin !== null && this.registrationId !== null) { 
            this.id = this.registrationId;
          } else {
            this.id = await auth.validate(this.username, this.firstname, this.lastname);
          }
          this.isVerified = true
          button.disabled = false;
          this.setError('')
        } catch (e) {
          if (parseInt(e) == Module.ErrorType.E_DUPLICATE.value)
          {
            this.setError(this.$t('login.alreadyExists'))
          }
          else
          {
            this.setError(this.$t('login.notInBeta'))
          }
          button.disabled = false;
        }
        return;
      }
    },
    async selectPaymentMethod() {
      if (this.pin.length == 0) {
        this.setError(this.$t('login.enterPin'))
        return;
      }
      if (this.password.length == 0) {
        this.setError(this.$t('login.enterPassword'))
        return;
      }

      let strongPassword = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})')
      if (!strongPassword.test(this.password)) {
        this.setError(this.$t('login.incorrectPassword'))
        return;
      }
      if (this.password !== this.passwordConfirm) {
        this.setError(this.$t('login.passwordsDontMatch'))
        return
      }
      try {
        if (this.accountHandleJoin !== null && this.accountKeyJoin !== null && this.registrationId !== null) {
          try {
            await auth.joinAccount(this.accountHandleJoin, this.accountKeyJoin, this.registrationId, this.firstname, this.lastname, this.username, this.password, this.pin);
            await auth.validateLogin();
            await Promise.all([
              this.setAccountHandleJoin(null),
              this.setAccountKeyJoin(null),
              this.setRegistrationId(null),
            ]);
            this.finish();
          } catch (e) {
            this.$showError(e);
          }
        } else {
          await auth.signup(this.id, this.username, this.password, this.pin, this.firstname, this.lastname, this.referrerCodeTemp.trim(), this.tarifaSeleccionada.id);
          if (this.referrerCodeTemp !== '') { 
            this.$router.replace({ path: '/register', query: { email: Base64.encodeURI(this.username), firstname: Base64.encodeURI(this.firstname), lastname: Base64.encodeURI(this.lastname), id: this.id, coupon: Base64.encodeURI(this.referrerCodeTemp) } });
          } else {
            this.$router.replace({ path: '/register', query: { email: Base64.encodeURI(this.username), firstname: Base64.encodeURI(this.firstname), lastname: Base64.encodeURI(this.lastname), id: this.id } });
          }
          // Finish registration process when price equals zero without asking for payment method configuration
          if (this.precioTarifa === 0) {
            this.finish();
          } else {
            this.createMode = 3;
          }
        }
      } catch (e) {
        if (e == Module.ErrorType.E_INVOICING.value)
        {
          this.$router.push({ path: '/promo' })
          return;
        }
        if (e == Module.ErrorType.E_COUPON.value) {
          this.setError(this.$t('login.wrongReferrerCode'))
          button.disabled = false;
          return;
        }
        this.setError(this.$t('login.wrongPin'))
        button.disabled = false;
      }
    },
    gtag_report_conversion (url) {
      var callback = function () {
        if (typeof(url) != 'undefined') {
          window.location = url;
        }
      };
      gtag('event', 'conversion', {
          'send_to': 'AW-369408594/wmf8CN_MkfoCENL0krAB',
          'transaction_id': '',
          'event_callback': callback
      });
      return false;
    },
    setError(error) {
      this.error = error
      var thisComponent = this
      setTimeout(function(){ thisComponent.error = '' }, 5000);
    }
  }
}
</script>
